<template>
  <div class="sw-modal confirm-dialog edit-form-component whatsapp-use-template">
    <div v-click-outside="cancelAction" class="sw-modal-content">
      <div class="row sw-modal-heading">
        <div class="col">
          <h4>Message using a Template</h4>
        </div>
      </div>
      <div class="sw-modal-body">
        <ValidationObserver ref="sendUsingTemplateForm">
          <form v-on:submit.prevent="sendAction()" >

            <div class="row question">
              <div class="col-12 question__question">
                <label for="template">WhatsApp Template</label>
                <div>
                  <select v-if="selectedChat.conversationWindowOpen" v-model="templateReference" id="template" v-on:change="changeTemplate()">
                    <option v-bind:value="null">Select a Template</option>
                    <option v-for="(template) of nonFormInviteWhatsAppTemplates" v-bind:key="template.reference" v-bind:value="template.reference">{{template.name}}</option>
                  </select>
                  <select v-else v-model="templateReference" id="template" v-on:change="changeTemplate()">
                    <option v-bind:value="null">Select a Template</option>
                    <option v-for="(template) of approvedNonFormInviteWhatsAppTemplates" v-bind:key="template.reference" v-bind:value="template.reference">{{template.name}}</option>
                  </select>
                </div>
              </div>
            </div>

            <div v-if="templateRequiresBooking" class="row question">
              <div class="col-12 question__question">
                <label for="template">Use a booking to personalise the content</label>
                <div>
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <select v-model="bookingReference" id="booking" v-on:change="personaliseContentForBooking()">
                      <option v-bind:value="null">Select a Booking</option>
                      <option v-for="(booking) of selectedChat.bookings" v-bind:key="booking.reference" v-bind:value="booking.reference">{{booking.arrival}} - {{booking.departure}}</option>
                    </select>
                    <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>

            <div v-if="template" class="row question">
              <div class="col-12 question__question whatsapp-use-template__content">

                <label for="template">Content</label>

                <ul v-if="selectedChat.conversationWindowOpen">
                  <li class="text-note">Conversation open - optionally edit content</li>
                  <li v-if="hasActions" class="text-note" v-bind:class="{'text-error': contentChanged}">If you edit, template buttons cannot be sent</li>
                </ul>

                <div v-if="hasMedia" class="col-12 preview-template__media">
                    <img v-if="hasImageMedia" :src="template.media[0].url" alt="Media">
                    <video v-if="hasVideoMedia" :src="template.media[0].url" controls></video>
                    <audio v-if="hasAudioMedia" :src="template.media[0].url" controls></audio>
                    <div v-if="hasPDFMedia" class="preview-template__media__embed-wrapper" :style="{ '--embed-height': normalizedHeight }">
                        <embed :src="template.media[0].url" type="application/pdf"/>
                    </div>
                </div>

                <div v-show="loadingTemplateContent">
                  <spinner></spinner>
                </div>

                <textarea v-show="!loadingTemplateContent" ref="content" v-model="content" v-on:input="contentChanged=true" v-bind:disabled="!selectedChat.conversationWindowOpen" class="long-question"></textarea>

                <div v-if="hasActions && !contentChanged">
                  <div v-for="(action, index) in template.actions" v-bind:key="index" class="message__footer">
                      <div class="message__footer--form-invite">
                          <a v-bind:href="action.url" target="_blank">
                          <i class="fa-solid fa-arrow-up-right-from-square"></i>
                          {{action.title}}
                          </a>
                      </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="sw-modal-actions">
              <div class="row">
                <div class="col text-center">
                  <div v-if="loadingTemplateContent || error" class="infobar" v-bind:class="{'infobar-info' : !error, 'infobar-error' : error}">
                    {{infoMessage}}
                  </div>
                </div>
              </div>
              <div class="row" v-show="!loadingTemplateContent && !success">
                <div class="col-6">
                  <button class="btn btn-normal" v-on:click.stop="cancelAction()">Cancel</button>
                </div>
                <div class="col-6">
                  <button class="btn btn-primary" v-bind:disabled="!content">Send</button>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
    // import Vue from 'vue';
    import {ValidationObserver, ValidationProvider} from 'vee-validate'

    import { store } from '../../store.js'

    import Spinner from '../../components/Spinner.vue'

    import {variablesMixin} from "../../mixins/VariablesMixin"
    import {whatsAppTemplateMixin} from "../../mixins/WhatsAppTemplateMixin"
    import {whatsAppTemplatesMixin} from "../../mixins/WhatsAppTemplatesMixin"

    export default {
        name: 'AddUsingTemplateDialog',
        components: {
          ValidationObserver, ValidationProvider, Spinner
        },
        mixins: [variablesMixin, whatsAppTemplateMixin, whatsAppTemplatesMixin],
        props: {
            selectedChat: Object
        },
        data: function() {
            return {
                templateReference: null,
                template: null,
                loadingTemplateContent: false,
                templateRequiresBooking: false,
                bookingReference: null,
                contentChanged: false,
                error: false,
                success: false,
                infoMessage: "",
                content: ""
            }
        },
        computed: {
        },
        methods: {
            changeTemplate: function() {
                this.template = null;
                this.templateRequiresBooking = false;
                this.bookingReference = null;
                this.contentChanged = false;
                this.error = false;
                this.success = false;
                this.infoMessage = "";
                this.content = "";
                if (this.templateReference) {
                    for (let template of this.whatsAppTemplates) {
                        if (template.reference === this.templateReference) {
                            this.template = template;
                            this.loadContentAndPersonalise(template);
                            break;
                        }
                    }
                } else {
                    this.content = "";
                }
            },
            loadContentAndPersonalise: async function(template) {
                this.template = template;
                this.attachFilesAsMediaOnTemplate(this.template);
                let hasBookingVariables = false;
                let previewText = template.content;
                let variablesInTemplate = previewText.matchAll(/\${(.+?)}/g);
                if (variablesInTemplate) {
                    for (let templateVariable of variablesInTemplate) {
                        if (this.variablesCopy.filter((variable) => variable.name === templateVariable[1]).length > 0) {
                            hasBookingVariables = true;
                            break;
                        }
                    }
                }

                if (hasBookingVariables) {
                    console.log("Has Booking variable - choose Booking");
                    this.templateRequiresBooking = true;
                }
                return this.personaliseContentForEstablishment();
            },
            personaliseContentForEstablishment: async function() {
                this.loadingTemplateContent = true;
                this.infoMessage = "Loading template and personalising";
                try {
                    const response = await this.$http.post('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/templates/' + this.templateReference + "/personalise-for-establishment", {
                        withCredentials: true
                    });
                    if (response.data) {
                        this.content = response.data;
                        let textarea = this.$refs.content;
                        textarea.focus();
                        this.$nextTick(() => textarea.setSelectionRange(0, 0));
                    }
                } catch (error) {
                    this.error = true;
                    if (error.response) {
                        this.infoMessage = error.response.data.message + ". Please try again or write by hand.";
                    } else {
                        this.infoMessage = "There was an error loading your template. Please try again or write by hand.";
                    }
                } finally {
                    this.loadingTemplateContent = false;
                }
            },
            personaliseContentForBooking: async function() {
                if (this.bookingReference === null) {
                    this.personaliseContentForEstablishment();
                    return;
                }

                console.log("Personalising for booking: " + this.bookingReference);
                this.loadingTemplateContent = true;
                this.error = false;
                this.infoMessage = "Loading template and personalising";
                let body = {
                    reference: this.bookingReference
                }
                try {
                    const response = await this.$http.post('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/templates/' + this.templateReference + "/personalise-for-booking", body);
                    if (response.data) {
                        this.content = response.data;
                        let textarea = this.$refs.content;
                        textarea.focus();
                        this.$nextTick(() => textarea.setSelectionRange(0, 0));
                    }
                } catch (error) {
                    this.error = true;
                    if (error.response) {
                        this.infoMessage = error.response.data.message + ". Please try again or write by hand.";
                    } else {
                        this.infoMessage = "There was an error loading your template. Please try again or write by hand.";
                    }
                } finally {
                    this.loadingTemplateContent = false;
                }
            },
            cancelAction: function() {
                this.$root.$emit("close-using-template-dialog");
            },
            sendAction: function() {
                this.$refs.sendUsingTemplateForm.validate().then(success => {
                    console.log("Validated:" + success);
                    if (!success) {
                        return
                    }

                    if (this.selectedChat.conversationWindowOpen && this.contentChanged) {
                        this.$root.$emit("send-free-form-message", this.content, this.template.media);
                    } else {
                        this.$root.$emit("send-template-message", this.templateReference, this.bookingReference);
                    }
                });
            },
        },
        mounted() {
            this.fetchVariables();
            this.fetchWhatsAppTemplates();
        }
    }
</script>

<style lang="scss" scoped>
  @import "../../styles/layout/forms.scss";
  @import "../../styles/components/modal.scss";
  @import "../../styles/components/edit_establishment.scss";
  @import "../../styles/components/edit_form_component.scss";
  @import "../../styles/components/question_answer.scss";
  @import "../../styles/components/message.scss";
  @import "../../styles/components/preview_template.scss";
  @import "../../styles/pages/whatsapp-use-template.scss";
</style>